import { useState } from "react";
import { Copy, Check } from "lucide-react";

export default function CopyButton({ text, className = "", label = false }) {
  const [copied, setCopied] = useState(false);
  const onClick = (e) => {
    e?.stopPropagation();
    if (!text) return;
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };
  return (
    <button
      onClick={onClick}
      data-testid="copy-btn"
      className={`inline-flex items-center gap-1 text-xs text-slate-500 hover:text-slate-900 hover:bg-slate-100 rounded px-2 py-1 transition-colors ${className}`}
      title="Copy"
    >
      {copied ? <Check className="w-3.5 h-3.5 text-green-500" /> : <Copy className="w-3.5 h-3.5" />}
      {label && <span>{copied ? "Copied" : "Copy"}</span>}
    </button>
  );
}
